export default __webpack_public_path__ + "static/BlinkFitness_Strong-7620a9110774e321565c163270b19eb7.ttf";